// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"0a88262702c9aed8","5405":"0e785b558a2c0b64","6219":"0e785b558a2c0b64"}[chunkId] + ".css";
};